import { render, staticRenderFns } from "./downLoadModal.vue?vue&type=template&id=5897182c&scoped=true"
import script from "./downLoadModal.vue?vue&type=script&lang=js"
export * from "./downLoadModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5897182c",
  null
  
)

export default component.exports